import { render } from "./ProjectTask.vue?vue&type=template&id=6972ec92&scoped=true"
import script from "./ProjectTask.vue?vue&type=script&lang=js"
export * from "./ProjectTask.vue?vue&type=script&lang=js"

import "./ProjectTask.vue?vue&type=style&index=0&id=6972ec92&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6972ec92"]])

export default __exports__